<template>
    <UserPageLayout>
        <div style="margin-bottom: 4rem;">
            <h1 class="text-white text-center text-3xl">What is The Big Quiz</h1>
        </div>
        <div class="max-w-lg mx-auto text-white">
            <p class="pb-2">
                <strong>The Big Quiz</strong> is a web app for playing and creating live quizes. 
                Create your own quizes or pick one of our public quizes.
            </p>
            <p class="pb-2">Players can join your quiz by using the unique pin on the /Join page or by scanning the QR.</p>
            <p>
                On public quizes you can choose to be Quizmaster or join as a player your self.
                On your own quizes you will always be quizmaster.
            </p>
            <h2 class="shadow-text-none">It’s free to play and create.</h2>
            <p class="pb-2">
                5 players can join a quiz. But for a small fee you can have up to 100 player in quiz.
                You also get access to reports and more question types.
            </p>
            <p>You can have up to 10 active quizes in “my quizes” in the free version.</p>
            <h2 class="shadow-text-none">Teachers</h2>
            <p>
                Test and educate your students with a live quiz.
                Use Interaction and fun to engage.
            </p>
            <h2 class="shadow-text-none">Business</h2>
            <p>
                Best ice breaker ever - Start off the meeting with a Live quiz.
                Use quiz to educate your emplyes and customers.
            </p>
            <h2 class="shadow-text-none">Party</h2>
            <p>
                Everybody loves a good quiz. With a live quiz from <strong><a href="http://thebigquiz.net/" style="color: white">thebigquiz.net</a></strong>
                everybody will ineteract and engaged.
            </p>
            <h2 class="shadow-text-none">Family</h2>
            <p>
                Birthday party? Family gathtering?
                Make a quiz about the jubilee or any of the guests
            </p>
            <h2 class="shadow-text-none">Events</h2>
            <p>
                Have upcoming event?
                Use a live quiz to get the attention of the visitors.
            </p>
        </div>
        <div style="margin-bottom: 12rem;"></div>
    </UserPageLayout>
</template>

<script>

import UserPageLayout from '@/layouts/UserPage'

export default {
    components: {
        UserPageLayout
    },

    mounted () {
        document.body.style.overflow = 'auto'
    }
}
</script>